export const TRIGGER_OPTIONS_BY_MODULE = {
  task: [
    { value: "add", label: "Create" },
    { value: "edit", label: "Update" },
    {
      value: "add_edit",
      label: "Create/Update",
    },
    // {
    //   value: "delete",
    //   label: "Delete",
    // },
    { value: "scheduledEvents", label: "Scheduled Events" },
  ],
  lead: [
    { value: "add", label: "Create" },
    { value: "edit", label: "Update" },
    {
      value: "add_edit",
      label: "Create/Update",
    },
    // {
    //   value: "delete",
    //   label: "Delete",
    // },
    { value: "scheduledEvents", label: "Scheduled Events" },
  ],
  contact: [
    { value: "add", label: "Create" },
    { value: "edit", label: "Update" },
    {
      value: "add_edit",
      label: "Create/Update",
    },
    // {
    //   value: "delete",
    //   label: "Delete",
    // },
    { value: "scheduledEvents", label: "Scheduled Events" },
  ],
  quotation: [
    { value: "add", label: "Create" },
    { value: "edit", label: "Update" },
    {
      value: "add_edit",
      label: "Create/Update",
    },
    // {
    //   value: "delete",
    //   label: "Delete",
    // },
    { value: "scheduledEvents", label: "Scheduled Events" },
  ],
  project: [
    { value: "add", label: "Create" },
    { value: "edit", label: "Update" },
    {
      value: "add_edit",
      label: "Create/Update",
    },
    // {
    //   value: "delete",
    //   label: "Delete",
    // },
    { value: "scheduledEvents", label: "Scheduled Events" },
  ],
  sales: [
    { value: "add", label: "Create" },
    { value: "edit", label: "Update" },
    {
      value: "add_edit",
      label: "Create/Update",
    },
    // {
    //   value: "delete",
    //   label: "Delete",
    // },
    { value: "scheduledEvents", label: "Scheduled Events" },
  ],
    invoice: [
    { value: "add", label: "Create" },
    { value: "edit", label: "Update" },
    {
      value: "add_edit",
      label: "Create/Update",
    },
    // {
    //   value: "delete",
    //   label: "Delete",
    // },
    { value: "scheduledEvents", label: "Scheduled Events" },
  ],
  recurringInvoice: [
    { value: "add", label: "Create" },
    { value: "edit", label: "Update" },
    {
      value: "add_edit",
      label: "Create/Update",
    },
    // {
    //   value: "delete",
    //   label: "Delete",
    // },
    { value: "scheduledEvents", label: "Scheduled Events" },
  ],
  purchase: [
    { value: "add", label: "Create" },
    { value: "edit", label: "Update" },
    {
      value: "add_edit",
      label: "Create/Update",
    },
    // {
    //   value: "delete",
    //   label: "Delete",
    // },
    { value: "scheduledEvents", label: "Scheduled Events" },
  ],
  company: [
    { value: "add", label: "Create" },
    { value: "edit", label: "Update" },
    {
      value: "add_edit",
      label: "Create/Update",
    },
    // {
    //   value: "delete",
    //   label: "Delete",
    // },
    { value: "scheduledEvents", label: "Scheduled Events" },
  ],
  deal: [
    { value: "add", label: "Create" },
    { value: "edit", label: "Update" },
    {
      value: "add_edit",
      label: "Create/Update",
    },
    // {
    //   value: "delete",
    //   label: "Delete",
    // },
    { value: "scheduledEvents", label: "Scheduled Events" },
  ],
};

// Lead properties (same as before)
export const LEAD_PROPERTY_CONFIG = [
   // { value: "contact_name", label: "Contact Name", type: "text" },,

  { value: "pipeline_id", label: "PipeLine", type: "pipelineSelect" },
  // { value: "pipeline_stage", label: "Pipeline Stage", type: "text" },
  { value: "owner_id", label: "Lead Owner", type: "ownerSelect" },

  {
    value: "expected_closure_date",
    label: "Expected Closure Date",
    type: "expected_closure_date",
  },
  { value: "lead_source_id", label: "Lead Source", type: "leadSource" },
  // {
  //   value: "product_services",
  //   label: "Product Service",
  //   type: "productService",
  // },
  { value: "company_name", label: "Company Name", type: "text" },
  { value: "industry", label: "Company Industry", type: "text" },

  { value: "total_budget", label: "Total Budget", type: "totalBudget" },
];
export const DEAL_PROPERTY_CONFIG = [
   // { value: "contact_name", label: "Contact Name", type: "text" },,

  { value: "pipeline_id", label: "PipeLine", type: "pipelineSelect" },
  { value: "deal_status", label: "Deal Status", type: "dealStatus" }, //banana hai
  // { value: "pipeline_stage", label: "Pipeline Stage", type: "text" },
  { value: "owner_id", label: "Lead Owner", type: "ownerSelect" },

  {
    value: "expected_closure_date",
    label: "Expected Closure Date",
    type: "expected_closure_date",
  },
  { value: "lead_source_id", label: "Lead Source", type: "leadSource" },
  // {
  //   value: "product_services",
  //   label: "Product Service",
  //   type: "productService",
  // },
  { value: "company_name", label: "Company Name", type: "text" },
  { value: "industry", label: "Company Industry", type: "text" },

  { value: "total_budget", label: "Total Budget", type: "totalBudget" },
];
export const COMPANY_PROPERTY_CONFIG = [
  { value: "email", label: "Primary Email", type: "email" },
  { value: "phone", label: "Primary Phone", type: "tel" },
  { value: "owner_id", label: "Lead Owner", type: "ownerSelect" },
  // { value: "city", label: "City", type: "city" },
  // { value: "state", label: "State", type: "state" },
  // { value: "country", label: "Country", type: "country" },
  { value: "company_name", label: "Company Name", type: "text" },
  { value: "industry", label: "Company Industry", type: "text" },
];

// Quotation fields
export const QUOTATION_PROPERTY_CONFIG = [
  // { value: "quotationValue", label: "Quotation Value", type: "number" },
  {
    value: "quotation_status",
    label: "Status",
    type: "quotationStatus", 
  },
  { value: "company_name", label: "Company Name", type: "text" },
  { value: "industry", label: "Company Industry", type: "text" },
    // { value: "contact_name", label: "Contact Name", type: "text" },,
  {value :"quotation_date",label :"Quotation Date" ,type :"date"},
  {value :"expiry_date",label :"Expiry Date" ,type :"date"},
  // {value :"deal_name",label :"Deal Name" ,type :"text"},
  { value: "owner_id", label: "Lead Owner", type: "ownerSelect" },
  {value :"total_amount",label :"Total Amount" ,type :"number"},
  // {
  //   value: "product_services",
  //   label: "Product Service",
  //   type: "productService",
  // },
  //  { value: "billing_city", label: "Billing City", type: "city" },
  // { value: "billing_state", label: "Billing State", type: "state" },
  // { value: "billing_country", label: "Billing Country", type: "country" },
  //   { value: "shipping_city", label: "Shipping City", type: "city" },
  // { value: "shipping_state", label: "shippinging State", type: "state" },
  // { value: "shipping_country", label: "shipping Country", type: "country" },
];
export const SALES_PROPERTY_CONFIG = [

    // { value: "contact_name", label: "Contact Name", type: "text" },,
  // {
  //   value: "quotationStatus",
  //   label: "Status",
  //   type: "quotationStatus", 
  // },
  { value: "company_name", label: "Company Name", type: "text" },
  { value: "industry", label: "Company Industry", type: "text" },
  {value :"sales_order_date",label :"Sales Order Date" ,type :"date"},
  {value :"shipment_date",label :"Shipment Date" ,type :"date"},
  // {value :"deal_name",label :"Deal Name" ,type :"text"},
  { value: "owner_id", label: "Lead Owner", type: "ownerSelect" },
  {value :"total_amount",label :"Total Amount" ,type :"number"},
  // {
  //   value: "product_services",
  //   label: "Product Service",
  //   type: "productService",
  // },
   {
    value: "order_status",
    label: "Status",
    type: "quotationStatus", 
  },
   
];
export const INVOICE_PROPERTY_CONFIG = [

    // { value: "contact_name", label: "Contact Name", type: "text" },,
  // {
  //   value: "quotationStatus",
  //   label: "Status",
  //   type: "quotationStatus", 
  // },
  
  {value :"invoice_date",label :"Invoiced Date" ,type :"date"},
  {value :"due_date",label :"Due Date" ,type :"date"},
 { value: "company_name", label: "Company Name", type: "text" },
  { value: "industry", label: "Company Industry", type: "text" },
  { value: "owner_id", label: "Lead Owner", type: "ownerSelect" },
  {value :"total_amount",label :"Total Amount" ,type :"number"},
  // {
  //   value: "product_services",
  //   label: "Product Service",
  //   type: "productService",
  // },
   
];
export const RECURRING_INVOICE_PROPERTY_CONFIG = [

    // { value: "contact_name", label: "Contact Name", type: "text" },,
  // {
  //   value: "quotationStatus",
  //   label: "Status",
  //   type: "quotationStatus", 
  // },
  { value: "company_name", label: "Company Name", type: "text" },
  { value: "industry", label: "Company Industry", type: "text" },
  {value :"invoice_date",label :"Invoiced Date" ,type :"date"},
  {value :"due_date",label :"Due Date" ,type :"date"},
 
  { value: "owner_id", label: "Lead Owner", type: "ownerSelect" },
  {value :"total_amount",label :"Total Amount" ,type :"number"},
  // {
  //   value: "product_services",
  //   label: "Product Service",
  //   type: "productService",
  // },
   
];
export const PURCHASE_PROPERTY_CONFIG = [
   // { value: "contact_name", label: "Contact Name", type: "text" },,
  // {
  //   value: "quotationStatus",
  //   label: "Status",
  //   type: "quotationStatus", 
  // },
  
  {value :"po_date",label :"Purchase Date" ,type :"date"},
  {value :"expected_delivery_date",label :"Delivery Date" ,type :"date"},
  // {value :"deal_name",label :"Deal Name" ,type :"text"},
  { value: "owner_id", label: "Lead Owner", type: "ownerSelect" },
  {value :"total_amount",label :"Total Amount" ,type :"number"},
{ value: "company_name", label: "Company Name", type: "text" },
  { value: "industry", label: "Company Industry", type: "text" },
  // {
  //   value: "product_services",
  //   label: "Product Service",
  //   type: "productService",
  // },
  //  { value: "billing_city", label: "Billing City", type: "city" },
  // { value: "billing_state", label: "Billing State", type: "state" },
  // { value: "billing_country", label: "Billing Country", type: "country" },
  //   { value: "shipping_city", label: "Shipping City", type: "city" },
  // { value: "shipping_state", label: "shippinging State", type: "state" },
  // { value: "shipping_country", label: "shipping Country", type: "country" },
];
// Project fields
// export const PROJECT_PROPERTY_CONFIG = [
//   { value: "projectName", label: "Project Name", type: "text" },
//   { value: "startDate", label: "Start Date", type: "date" },
//   { value: "endDate", label: "End Date", type: "date" },
//   {
//     value: "projectStatus",
//     label: "Status",
//     type: "projectStatus", // select
//   },
// ];

// Minimal Task fields (optional – you can expand later)
// export const TASK_PROPERTY_CONFIG = [
//   { value: "taskTitle", label: "Task Title", type: "text" },
//   {
//     value: "taskOwner",
//     label: "Task Owner",
//     type: "ownerSelect",
//   },
// ];

// Contact fields
export const CONTACT_PROPERTY_CONFIG = [
  //  // { value: "contact_name", label: "Contact Name", type: "text" },,
   { value: "first_name", label: "First Name", type: "text" },
    { value: "last_name", label: "Last Name", type: "text" },
  { value: "company_name", label: "Company Name", type: "text" },
  { value: "phone", label: "Phone", type: "text" },
  { value: "email", label: "Email", type: "text" },
  // { value: "city", label: "City", type: "text" },
  // { value: "state", label: "State", type: "text" },
  { value: "owner_id", label: "Owner", type: "ownerSelect" },
  // { value: "city", label: "City", type: "city" },
  // { value: "state", label: "State", type: "state" },
  // { value: "country", label: "Country", type: "country" },
  { value: "department", label: "Department", type: "text" },
  { value: "designation", label: "Designation", type: "text" },
  { value: "lead_source_id", label: "Lead Source", type: "leadSource" },
];








export const NUMBER_OPERATORS = [
  { value: "is", label: "Is" },
  { value: "is_not", label: "Is not" },
  { value: "less_than", label: "Is less than" },
  // { value: "lte", label: "Is less than or equal to" },
  { value: "greater_than", label: "Is greater than" },
  // { value: "gte", label: "Is greater than or equal to" },
  { value: "between", label: "Between" }, //  special (min/max)
  { value: "is_empty", label: "Is empty" },
  { value: "is_not_empty", label: "Is not empty" },
];









/** FIELD CONFIG PER MODULE */

export const PROPERTY_CONFIG_BY_MODULE = {
  Lead: LEAD_PROPERTY_CONFIG,
  Contact: CONTACT_PROPERTY_CONFIG,
  Quotation: QUOTATION_PROPERTY_CONFIG,
  // Project: PROJECT_PROPERTY_CONFIG,
  // Task: TASK_PROPERTY_CONFIG,
};


 export  const BODY_VARIABLE_OPTIONS = [
    { value: "contact_name", label: "Contact Name" },
    { value: "contact_phone", label: "Contact Phone" },
    { value: "contact_email", label: "Contact Email" },
    { value: "owner_name", label: "Owner Name" },
    { value: "owner_phone", label: "Owner Phone" },
    { value: "owner_email", label: "Owner Email" },
    { value: "org_name", label: "Organization Name" },
    { value: "org_phone", label: "Organization Phone" },
    { value: "org_email", label: "Organization Email" },
    { value: "company_name", label: "Company Name" },
    { value: "company_phone", label: "Company Phone" },
    { value: "company_email", label: "Company Email" },
  ];


 export const MODULE_OPTIONS = [
    // { value: "Task", label: "Task" },
    { value: "lead", label: "Leads" },
    { value: "deal", label: "Deal" },
    { value: "contact", label: "Contact" },
    { value: "company", label: "Company" },
    { value: "quotation", label: "Quotation" },
    { value: "sales", label: "Sales" },
    { value: "purchase", label: "Purchase" },
    { value: "invoice", label: "Invoice" },
    { value: "recurringInvoice", label: "Recurring Invoice" },
    // { value: "Project", label: "Project" },
  ];
  
 export const TEXT_OPERATORS = [
    { value: "is", label: "Is" },
    { value: "isNot", label: "Is not" },
    { value: "startsWith", label: "Starts with" },
    { value: "endsWith", label: "Ends with" },
    { value: "contains", label: "Contains" },
    { value: "notContains", label: "Not contains" },
    { value: "isEmpty", label: "Is empty" },
    { value: "isNotEmpty", label: "Is not empty" },
  ];
  
 export const OWNER_OPERATORS = [
    { value: "is", label: "Is" },
    { value: "isNot", label: "Is not" },
    { value: "isEmpty", label: "Is empty" },
    { value: "isNotEmpty", label: "Is not empty" },
  ];
 export const PRODUCT_OPERATORS = [
    { value: "is", label: "Is" },
    { value: "isNot", label: "Is not" },
    { value: "isEmpty", label: "Is empty" },
    { value: "isNotEmpty", label: "Is not empty" },
  ];
 export const EXPECTED_CLOSURE_DATE = [
    { value: "after", label: "After" },
    { value: "before", label: "Before" },
    { value: "between", label: "Between" },
    { value: "is", label: "Is" },
    { value: "isNot", label: "Is not" },
    { value: "isEmpty", label: "Is empty" },
    { value: "isNotEmpty", label: "Is not empty" },
  ];
 export const TOTAL_BUDGET_OPERATOR = [
    { value: "is", label: "is" },
    { value: "less_than", label: "Less Than" },
    { value: "greater_than", label: "Greater Than" },
    { value: "greater_than_equal_to", label: "Greater Than Equal To" },
    { value: "less_than_equal_to", label: "Less Than Equal To" },
  ];
  
 export const LEAD_STAGE_OPTIONS = [
    { value: "CONTACTED", label: "CONTACTED" },
    { value: "HOT", label: "HOT" },
    { value: "CLOSED_WON", label: "CLOSED WON" },
  ];
  
 export const QUOTATION_STATUS_OPTIONS = [
    { value: "Draft", label: "Draft" },
    { value: "Sent", label: "Sent" },
    { value: "Accepted", label: "Accepted" },
    { value: "Rejected", label: "Rejected" },
  ];
  
export  const PROJECT_STATUS_OPTIONS = [
    { value: "NotStarted", label: "Not Started" },
    { value: "InProgress", label: "In Progress" },
    { value: "Completed", label: "Completed" },
  ];
  
 export const ACTION_OPTIONS = [
    { value: "sendEmail", label: "Send Email" },
    { value: "sendWhatsapp", label: "Send WhatsApp" },
    // { value: "updateField", label: "Update Field" },
    // { value: "createTask", label: "Create Task" },
  ];
  
  export const TRIGGER_LABEL_MAP = {
  add: "Create",
  edit: "Update",
  add_edit: "Create/Update",
};